'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Klasický select
 */
var SelectField = function (_AbstractField) {
    (0, _inherits3.default)(SelectField, _AbstractField);

    function SelectField() {
        (0, _classCallCheck3.default)(this, SelectField);
        return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                children = _props.children,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'children']);


            var field = _react2.default.createElement(
                _reactstrap.Input,
                (0, _extends3.default)({
                    type: 'select'
                }, props),
                children
            );

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return SelectField;
}(_AbstractField3.default);

exports.default = SelectField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvU2VsZWN0RmllbGQuanN4Il0sIm5hbWVzIjpbIlNlbGVjdEZpZWxkIiwicHJvcHMiLCJhZGRvbnNCZWZvcmUiLCJhZGRvbnNBZnRlciIsImNoaWxkcmVuIiwiZmllbGQiLCJyZW5kZXJGaWVsZFdpdGhBZGRvbnMiLCJBYnN0cmFjdEZpZWxkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7Ozs7O0FBRUE7OztJQUdNQSxXOzs7Ozs7Ozs7O2lDQUNPO0FBQUEseUJBQ21ELEtBQUtDLEtBRHhEO0FBQUEsZ0JBQ0VDLFlBREYsVUFDRUEsWUFERjtBQUFBLGdCQUNnQkMsV0FEaEIsVUFDZ0JBLFdBRGhCO0FBQUEsZ0JBQzZCQyxRQUQ3QixVQUM2QkEsUUFEN0I7QUFBQSxnQkFDMENILEtBRDFDOzs7QUFHTCxnQkFBTUksUUFBUTtBQUFDLGlDQUFEO0FBQUE7QUFDViwwQkFBSztBQURLLG1CQUVOSixLQUZNO0FBSVRHO0FBSlMsYUFBZDs7QUFPQSxtQkFBTyxLQUFLRSxxQkFBTCxDQUEyQkQsS0FBM0IsRUFBa0NILFlBQWxDLEVBQWdEQyxXQUFoRCxDQUFQO0FBQ0g7OztFQVpxQkksdUI7O2tCQWNYUCxXIiwiZmlsZSI6IlNlbGVjdEZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQge0lucHV0fSBmcm9tICdyZWFjdHN0cmFwJ1xuaW1wb3J0IEFic3RyYWN0RmllbGQgZnJvbSBcIi4vQWJzdHJhY3RGaWVsZFwiO1xuXG4vKipcbiAqIEtsYXNpY2vDvSBzZWxlY3RcbiAqL1xuY2xhc3MgU2VsZWN0RmllbGQgZXh0ZW5kcyBBYnN0cmFjdEZpZWxkIHtcbiAgICByZW5kZXIoKSB7XG4gICAgICAgIGNvbnN0IHthZGRvbnNCZWZvcmUsIGFkZG9uc0FmdGVyLCBjaGlsZHJlbiwgLi4ucHJvcHN9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICBjb25zdCBmaWVsZCA9IDxJbnB1dFxuICAgICAgICAgICAgdHlwZT1cInNlbGVjdFwiXG4gICAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgID5cbiAgICAgICAgICAgIHtjaGlsZHJlbn1cbiAgICAgICAgPC9JbnB1dD47XG5cbiAgICAgICAgcmV0dXJuIHRoaXMucmVuZGVyRmllbGRXaXRoQWRkb25zKGZpZWxkLCBhZGRvbnNCZWZvcmUsIGFkZG9uc0FmdGVyKTtcbiAgICB9XG59XG5leHBvcnQgZGVmYXVsdCBTZWxlY3RGaWVsZDtcbiJdfQ==